import IPageCategory from "@/models/IPageCategory";
import { PositionState } from "@/store/modules/crud/PositoinState";

export class State extends PositionState {
  dataList: Array<IPageCategory> = [];
  dataItem: IPageCategory | null = null;
}
